import "./main.scss"
import "blissfuljs"
import "lightbox2/dist/js/lightbox-plus-jquery.min.js"

const $ = window.Bliss
const $$ = $.$

import { Gallery } from "./js/gallery"
import { ToggleElements } from "./js/toggleElements"

import "./js/blog-grid"
import "./js/masonry-grid"
import "./js/photo-gallery"

import { Accordion } from "./js/accordion"
import ScrollMenu from "./js/scrollmenu"

const setInnerHTML = (elm, html) => {
  elm.innerHTML = html
  for (const oldScriptEl of elm.querySelectorAll("script")) {
    const newScriptEl = document.createElement("script")
    for (const attr of oldScriptEl.attributes) {
      newScriptEl.setAttribute(attr.name, attr.value)
    }
    newScriptEl.textContent = oldScriptEl.textContent
    oldScriptEl.replaceWith(newScriptEl)
  }
}

function initAjaxForm(container) {
  container.addEventListener("submit", (e) => {
    e.preventDefault()
    const form = e.target
    const body = new FormData(form)
    fetch(form.action, {
      method: "POST",
      credentials: "same-origin",
      body,
    })
      .then((response) => response.text())
      .then((html) => {
        setInnerHTML(container, html)
      })
      .catch(() => {
        container.innerHTML =
          "<p>Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite erneut und versuchen Sie es später noch einmal.</p>"
      })
  })

  fetch(container.dataset.form)
    .then((response) => response.text())
    .then((html) => {
      setInnerHTML(container, html)
    })
    .catch(() => {
      container.innerHTML =
        "<p>Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite erneut und versuchen Sie es später noch einmal.</p>"
    })
}

$.ready().then(() => {
  // let lightbox = window.lightbox
  //

  $$("[data-form]").forEach(initAjaxForm)

  if ($(".memberlist")) {
    new ToggleElements()
  }

  const $tableHead = $$(".memberlist-content")
  if ($tableHead) {
    $tableHead.forEach((e) => {
      const elements = e.querySelectorAll("tr").length
      e.parentNode.querySelector(".memberlist-number").innerHTML = elements
    })
  }

  const downloadSelector = $(".blogpage__download--selector")
  const downloadMobile = $(".blogpage__download-mobile")
  if (downloadSelector) {
    downloadSelector.addEventListener("click", (e) => {
      e.preventDefault()
      downloadMobile.classList.toggle("active")
    })
  }

  const dataRestricted = $$("[data-restricted]")

  dataRestricted.forEach((e) => {
    e.addEventListener("click", (x) => {
      x.preventDefault()
    })
  })

  // Image Loader

  // Blog Grid

  /*  let container = document.querySelector('.grid-gallery')
   if (container) {
   new Masonry(container, {
   columnWidth: '.grid-sizer',
   itemSelector: '.grid-gallery-item',
   horizontalOrder: true,
   })
   }*/

  const foldoutTrigger = $$(".nl-foldout-trigger input")
  const foldoutNl = $(".nl-foldout")
  if (foldoutTrigger) {
    foldoutTrigger.forEach((e) => {
      e.addEventListener("click", () => {
        if (!foldoutNl.classList.contains("is-visible")) {
          foldoutNl.classList.add("is-visible")
        }
      })
    })
  }

  $$("[data-accordion-id]").forEach((el) => new Accordion(el))

  // $$('form').forEach(form => new AjaxForm(form))

  /*
   *  Mobile Nav Toggle
   */
  $("[data-toggle-mobile-nav]").addEventListener("click", (e) => {
    e.preventDefault()
    document.body.classList.toggle("nav-is-open")
  })

  window.addEventListener("resize", () => {
    document.body.classList.remove("nav-is-open")
  })

  const navPlus = $$("[data-toggle-mobile-nav-sub]")
  navPlus.forEach((element) => {
    element.addEventListener("click", () => {
      const nextSubmenu = element.parentNode.querySelector(
        ".navigation__submenu",
      )
      const nextParent =
        element.parentNode.parentNode.querySelector(".navigation__item")
      // let nextClosestIcon = element.parentNode.querySelector('[data-toggle-mobile-nav-sub]')
      //nextParent.closest('[data-toggle-mobile-nav-sub]')
      nextParent.classList.toggle("is--open")
      nextSubmenu.classList.toggle("is--open")
      // nextClosestIcon.classList.toggle('rotate')

      element.classList.toggle("rotate")
    })
  })
  /*
   * Close navigation after a click on a link
   */
  const navigation = $(".navigation")
  $.delegate(navigation, "click", ".navigation__link", () => {
    document.body.classList.remove("nav-is-open")
  })

  /*
   * Gallery
   * =======
   */
  const sliders = $$(".gallery-slide:not(.gallery--none)")
  sliders.forEach((el) => {
    new Gallery(el, {
      interval: 5000,
      autoPlay: true,
      createThumbs: true,
      endless: false,
    })
  })

  // Sidenav

  /*  let sidenavLink = $$('[data-sidenav-has-children]');
   let sidenavToggle = $$('[data-sidenav-toggle]');
   if (sidenavToggle) {
   sidenavLink.forEach(e => {
   e.addEventListener('click', c => {
   c.target.parentNode.parentNode.parentNode.querySelector('.sidenav-children').classList.toggle('active')
   })
   })
   }*/

  /*  const galleries = $$('[data-gallery-slide]')
   galleries.forEach(el => {
   new GallerySlider(el, {
   interval: 5000,
   autoPlay: true,
   createThumbs: true,
   endless: false,
   })
   })*/

  // prix Litra Form

  const input = $$(".form-fieldset > input")

  if (input) {
    window.addEventListener("change", () => {
      input.forEach((e) => {
        if (!e.value === "") {
          e.classList.add("filled")
        } else {
          e.classList.remove("filled")
        }
      })
    })

    input.forEach((e) => {
      e.setAttribute("tabindex", 0)
      if (!e.value === "") {
        e.classList.add("filled")
      } else {
        e.classList.remove("filled")
      }
    })
  }

  /*
   *   Set scroll indicator
   */
  // Nobody actually listens for the scrolled CSS class
  // const scrolledThreshold = 20

  // window.addEventListener(
  //   "scroll",
  //   _throttle(() => {
  //     if (window.pageYOffset > scrolledThreshold) {
  //       document.body.classList.add("scrolled")
  //     } else {
  //       document.body.classList.remove("scrolled")
  //     }
  //   }, 100),
  // )
})

window.addEventListener("load", () => {
  // Anchors
  const scrollItem = $(".anchors")
  if (scrollItem) {
    new ScrollMenu([".anchors a"])
  }
})
